import consumer from './consumer'

// MEMO
// rails webpacker:install
// rails webpacker:compile
// bundle exec rails webpacker:install
// Node.jsで怒られるときは、
// export NODE_OPTIONS=--openssl-legacy-provider
// unset NODE_OPTIONS

// config/webpack/environment.jsの書き換えも忘れずに
// const { environment } = require('@rails/webpacker')
//
// const webpack = require('webpack')
// environment.plugins.prepend('Provide',
//     new webpack.ProvidePlugin({
//       $: 'jquery/src/jquery',
//       jQuery: 'jquery/src/jquery'
//     })
// )
// module.exports = environment


// これを試すと良いかも？
// yarn add webpack webpack-cli
// bin/rails webpacker:install
// bin/rails webpacker:compile


// const { environment } = require('@rails/webpacker')
//
// const webpack = require('webpack')
// environment.plugins.prepend('Provide',
//     new webpack.ProvidePlugin({
//       $: 'jquery/src/jquery',
//       jQuery: 'jquery/src/jquery'
//     })
// )
// module.exports = environment

// $(function() { ... }); で囲むことでレンダリング後に実行される
// レンダリング前に実行されると $('#messages').data('room_id') が取得できない
// turbolinks を使っている場合は $(document).on('turbolinks:load', function() { ... }); で囲う
$(function() {
// $(document).on('turbolinks:load', function() {
  // showの<div id='messages' data-room_id="<%= @room.id %>" data-icebreak="<%= params[:icebreak] %>">で、データをやり取りできそう
  const chatChannel = consumer.subscriptions.create({ channel: 'RoomChannel', room: $('#messages').data('room_id'), icebreak: $('#messages').data('icebreak') }, {
    connected() {
      // Called when the subscription is ready for use on the server
      console.log("connected");
      console.log("in:" + $('#messages').data('icebreak'));
    },

    disconnected() {
      // Called when the subscription has been terminated by the server
    },

    // room_channel.rbでブロードキャストされたものがここに届く
    received: function(data) {
      console.log(data)
      // if(data['message']['icebreak'] != $('#messages').data('icebreak')) return; // 今いる部屋のメッセージじゃないなら飛ばす
      if(data['message']['action'] == 1) { // 通常の発言
        let r = "#r" + data['message']['refer'];
        let p = "#p" + data['message']['place'];
        let inum = ".i" + data['message']['icebreak']; // tableを指定
        console.log("inum:" + inum + " r:" + r + " p:" + p);
        console.log($(inum).find(r).find(p));
        return $(inum).find(r).find(p).append(data['message']['message']);
      }else if(data['message']['action'] == 2){　// 削除
        // console.log("delete message");
        let delid = ".id" + data['message']['delid'];
        return $(delid).remove();
      }else if(data['message']['action'] == 3) { // 投票
        let r = "#r" + data['message']['refer'];
        let p = "#p" + data['message']['place'];
        let inum = ".i3_vote"; // tableを指定
        console.log($(inum).find(r).find(p));
        return $(inum).find(r).find(p).append(data['message']['message']);
      }else if(data['message']['action'] == 4){ // 行追加
        let doc = rowgen(data['message']['refer']);
        $(".table" + ".table-hover" + ".table-bordered").append(doc);
      }else if(data['message']['action'] == 5) { // リコメンド削除
        delrec(data['message']['refer']);
      }else if(data['message']['action'] == 6) { // 固有名詞検知
        // console.log("DETECTED 固有名詞");
        let alertmsg = "<h3 class='alert-danger'>固有名詞が入力された可能性があります。確認してください。</h3>";
        // let alertmsg = "<h3 class='alert-danger' style='color: red'>固有名詞が入力された可能性があります。確認してください。</h3>";
        let doc = document.querySelectorAll(".PROPN_area");
        for (const elm of doc) {
          $(elm).append(alertmsg);
        }
      }else if(data['message']['action'] == 7) { // いいね
        console.log("Liked : " + data['message']['id']);
        let doc = document.getElementsByClassName(data['message']['refer']);
        let cnt = 0
        for (const elm of doc) {
          cnt = $(elm).text();
        }
        cnt = parseInt(cnt, 10) + 1;
        for (const elm of doc) {
          $(elm).text(cnt);
        }
        // action 8 はいいねの取り消しに使用中！
      }else if(data['message']['action'] == 9) { // AIにより生成されたもの
        let elems = $("[id=genai_warning_text]");
        for(let elem of elems) {
          elem.remove();
        }
        let text_areas = $("[id=genai_generated_text_area]");
        for(let a of text_areas) {
          // 複数生成ボタンがある場合は目的のところまでコンティニュー
          if(a.dataset.refer != data['message']['refer'] || a.dataset.place != data['message']['place'] || a.dataset.icebreak != data['message']['icebreak']) continue;
          $(a).append("<p id=''>"+data['message']['message']+"</p>");
        }
      }else if(data['message']['action'] == 10) { // 前のステップへボタン
      }else if(data['message']['action'] == 11) { // 次のステップへボタン
      }else if(data['message']['action'] == 12) { // 個人宛の発言
        if(JSON.parse(document.getElementById('tag_info').dataset.json).id != data['message']['user_id']){
          console.log("skip");
          return;
        }
        let r = "#r" + data['message']['refer'];
        let p = "#p" + data['message']['place'];
        let inum = ".i" + data['message']['icebreak']; // tableを指定
        console.log("inum:" + inum + " r:" + r + " p:" + p);
        console.log($(inum).find(r).find(p));
        return $(inum).find(r).find(p).append(data['message']['message']);
      }else if(data['message']['action'] == 13) { // 画像生成ボタン
        let elems = $("[id=img_gen_warning_text]");
        for(let elem of elems) {
          elem.remove();
        }
        let text_areas = $("[id=generated_image_area]");
        for(let a of text_areas) {
          // 複数生成ボタンがある場合は目的のところまでコンティニュー
          if(a.dataset.refer != data['message']['refer'] || a.dataset.place != data['message']['place'] || a.dataset.icebreak != data['message']['icebreak']) continue;
          $(a).append("<img id='' class='generated_img' src='" + data['message']['delid'] + "' alt=\'AI生成画像\'>"+"</img>");
        }
      }else if(data['message']['action'] == 14) { // Wikipedia
      }

      // return $('.table-center').append(data['message']['message']);
    },

    // これが実行されるとコンシューマになったRoomChannel#speak({ message: message })が呼ばれる
    // action　１は通常投稿、２は削除、３は投票
    speak: function(message, actionval, delflg, icebreak) {
      console.log("speak:" + message);
      return this.perform('speak', {
        message: message,
        messageaction: actionval,
        delflg: delflg,
        icebreak: icebreak
      });
    }
  });

  // Enterキー
  $(document).on('keypress', function(event) {
    // console.log("keydown");
    if (event.keyCode === 13) {
      console.log("enter");
      // console.log("place:" + event.target.className);
      // console.log("name(refer):" + event.target.name);
      // chatChannel.speak([event.target.value, event.target.className.substr(1), event.target.name.substr(1)], 1, false); // [content, place, refer], action, delflgの順で渡す
      // event.target.value = '';
      // return event.preventDefault();
      return false; // Enter無効
    }
  });

  $(document).on("click", ".saiyou", function () {
    let t = '#f' + $(this).attr('id')[1];
    if(kaburicheck($(t).text(), 1, 0)) {
      chatChannel.speak([$(t).text(), 1, 0], 1, false, this.name.substr(1));
    }else{
      return;
    }
    // 暫定：時間調整　Speakを連続で呼ぶとDBがロックしちゃう
    for(let i = 0; i < 1000; i++){
      console.log("clicked");
    }
    console.log("place:" + $(this).attr('id'));
    chatChannel.speak([$(this).attr('id')[1], 0, $(this).attr('id')[1]], 5, false, this.name.substr(1)); // リコメンドを共通で削除のために飛ばす, referで削除するボタンを教える
  });

  // 組み合わせのステップで押すと追記してくれるやつ
  $('.step3').on('click', function() {
    // console.log("STEP3");
    // 追記するデータを定義しておきます
    // console.log(this.text);
    var addText = this.text + " ";
    let work = $('#r0' + '.p1');
    // 取得データと追記文言をくっつけて出力します
    work.val(work.val() + addText);
  });

  // $('.delete').on('click', function() {
  $(document).on("click", ".delete", function () {
    if(!confirm('削除しますか？\nDelete?')) return;
    console.log("delete");
    // console.log(this.dataset.icebreak);
    chatChannel.speak([this.value, this.id.substr(1), this.name.substr(1)], 2, true, this.dataset.icebreak); // [削除したいID, place, refer], action, delflg, icebreakの順で渡す
  });

  // 通常の送信
  $(document).on("click", ".send", function () {
    // console.log($('#messages').data('icebreak'));
    let r = this.id.substr(1);
    let p = this.name.substr(1);
    let w = "#r" + r;
    let w2 = ".p" + p;
    // console.log("w:" + w + " w2:" + w2);
    // console.log($(w + w2).val());
    let formid = ".r" + r + "p" + p + "i" + this.placeholder;

    if(kaburicheck($(formid).find(w + w2).val(), p, r))
      chatChannel.speak([$(formid).find(w + w2).val(), p, r], 1, false, this.placeholder); // [content, place, refer], action, delflg, icebreakの順で渡す
    // chatChannel.speak([$(w + w2).val(), p, r], 1, false, this.placeholder); // [content, place, refer], action, delflg, icebreakの順で渡す
    $(w + w2).val("");
    return event.preventDefault();
  });
  // 個人宛の送信
  $(document).on("click", ".personal_send", function () {
    // console.log($('#messages').data('icebreak'));
    let r = this.id.substr(1);
    let p = this.name.substr(1);
    let w = "#r" + r;
    let w2 = ".p" + p;
    // console.log("w:" + w + " w2:" + w2);
    // console.log($(w + w2).val());
    let formid = ".r" + r + "p" + p + "i" + this.placeholder;

    if(kaburicheck($(formid).find(w + w2).val(), p, r))
      chatChannel.speak([$(formid).find(w + w2).val(), p, r], 12, false, this.placeholder); // [content, place, refer], action, delflg, icebreakの順で渡す
    // chatChannel.speak([$(w + w2).val(), p, r], 1, false, this.placeholder); // [content, place, refer], action, delflg, icebreakの順で渡す
    $(w + w2).val("");
    return event.preventDefault();
  });

  $(document).on("click", ".vote", function () {
    console.log("user:" + this.id.substr(1) + " refer:" + this.name.substr(1));
    chatChannel.speak([this.id.substr(1), 1, this.name.substr(1)], 3, false, 3); // [content, place, refer], action, delflg, icebreakの順で渡す
  });

  $(document).on("click", ".add", function () {
    console.log("add");
    let len = $(".table" + ".table-hover" + ".table-bordered").children().children().length - 1; // 列の数を取得
    // referとiceberakが決め打ちになっているのでやる
    chatChannel.speak(["row added.", 1, (len + 1)], 4, false, 7); // [content, place, refer], action, delflg, icebreakの順で渡す
  });

  $(document).on("click", ".edit", function () {
    if(!confirm('修正を行いますか？\nEdit?')) return;
    console.log("edit");
    let addText = this.dataset.content;
    let r = "#" + this.dataset.refer;
    let p = "." + this.dataset.place;
    let work = $(r + p);
    // まずは消す
    chatChannel.speak([this.dataset.id, p.substr(2), r.substr(2)], 2, true, $('#messages').data('icebreak')); // [削除したいID, place, refer], action, delflg, icebreakの順で渡す
    // 取得データと追記文言をくっつけて出力します
    work.val(addText);
  });

  $(document).on("click", ".votecheck", function () {
    // 同数投票が行われていないかチェックする
    console.log("votecheck");
    let tr = $(".table" + ".table-hover" + ".table-bordered").children().children(); // テーブル取得
    let res = [];
    for(let i = 0; i < tr.length; i++){
      console.log(tr[i]);
      let t = $($(tr[i]).find("td").get(0)).text();
      t = t.replace(/\r?\n?\s/g,"");
      res.push({"text": t, "count": $(tr[i]).find("p").length});
    }
    // countでソートする
    res.sort(function(a, b) {
      return a.count - b.count;
    });
    res.reverse();

    let alerttext = "以下の言葉が同数投票です。続行しますか？\n\n";
    let flg = false;
    for(let i = 0; i < Math.min(res.length, 5); i++){ // 上位5つ（もしくは投稿数）において同数か判定する
      for(let k = i + 1; k < Math.min(res.length, 5); k++){
        if(res[i]["count"] == 0 || res[k]["count"] == 0) continue;
        if(res[i]["count"] == res[k]["count"]){
          flg = true;
          alerttext += (res[i]["text"] + " と " + res[k]["text"] + "\n");
        }
      }
    }
    alerttext += "\n※決選投票をオススメします。\n（キャンセル：投票画面に残る　OK：続行する）";
    if(flg) {
      if (!confirm(alerttext)) return false;
    }
  });

  // ChatGPTは重いので警告しておく
  $(document).on("click", ".chatgpt", function () {
    alert("別タブで処理を開始します。\n(処理に時間がかかります。気長にお待ち下さい。)");
    console.log("ChatGPT");
  });

  // 生成AIを用いたページで単語をクリックすると追加してくれるやつ
  $('.genai_content').on('click', function() {
    var addText = this.text;
    let work = $('#r0' + '.p1');
    // 取得データと追記文言をくっつけて出力
    work.val(work.val() + addText + ", ");

    // テーブルに追加する
    let addedtime = new Date();
    let tableElem = document.getElementById('genai_elements_table');
    let trElem = tableElem.tBodies[0].insertRow(-1);
    trElem.setAttribute("id", addedtime.getTime()); // 消すようにつけておく
    let cellElem = trElem.insertCell(0);
    let aelem = document.createElement("a");
    aelem.classList.add("genai_added_content");
    aelem.setAttribute("id", addedtime.getTime()); // 消すようにつけておく
    aelem.textContent = addText;
    cellElem.appendChild(aelem);
  });

  // 追加済みの単語を消す処理
  $(document).on("click", ".genai_added_content", function () {
    let addText = this.text;
    let addedtime = this.id;
    let work = $('#r0' + '.p1');
    let w = work.val();
    w = w.replace(addText + ", ", "");
    work.val(w);

    // テーブルから消す
    document.getElementById(addedtime).innerHTML = "";
  });

  // 生成AIを用いたページで著者をクリックするとプロンプトを追加してくれるやつ
  $('.genai_author').on('click', function() {
    var addText = "あなたは文豪東野圭吾です。容易に想像できない、奇想天外のストーリーを持つ小説のワンシーンを執筆してください。あなたが持っている有名SF小説の知識を思い出して、以下のテーマについて、2050年の世界を舞台とした物語のシナリオを作ってください（1000文字程度）。テーマ(Theme):";
    let work = $('#r0' + '.p1');
    // 取得データと追記文言をくっつけて出力します
    work.val(work.val() + addText + ", ");
    // removeする
    document.getElementById("authors_list").innerHTML = "";
  });

  // ChatGPTは重いので警告しておく
  $(document).on("click", "#chatgpt", function () {
    document.getElementById("gpt_process_alertarea").classList.add('alert');
    document.getElementById("gpt_process_alertarea").classList.add('alert-warning');
    let alert_text_area = $('#gpt_process_alertarea');
    alert_text_area.append("現在実行中です。ページが更新されるまで操作せず、しばらくお待ち下さい。");
  });

  // いいねを押す
  $(document).on("click", ".like-btn", function () {
    // console.log("LIKE");
    let classname = this.className;
    let content = this.dataset.content;
    let r = this.dataset.id; // referはいいねを押されたメッセージIDにしておく
    // console.log(r);
    let p = this.dataset.place;
    let i = this.dataset.icebreak;
    if(classname == "like-btn btn bi bi-heart"){
      // like
      chatChannel.speak([content, p.substr(1), r], 7, false, i); // [content, place, refer], action, delflg, icebreak
      this.className = "unlike-btn btn bi bi-heart"
    }else{
      // unlike 未実装
      // chatChannel.speak([content, p.substr(1), r], 8, false, i); // [content, place, refer], action, delflg, icebreak
      // this.className = "like-btn btn bi bi-heart"
    }
  });

  // AIボタンを押す
  $(document).on("click", ".genai-btn", function () {
    let alert_text_areas = $("[id=gpt_process_alertarea]");
    for(let a of alert_text_areas) {
      $(a).append("<p id='genai_warning_text'>現在実行中です。ページが更新されるまで操作せず、しばらくお待ち下さい。</p>");
    }

    // ボタンにdata-prpmptsを入れておくと、それを渡せる
    let d = this.dataset.prompts;
    // console.log(d);

    let icebreak = this.dataset.icebreak;
    if(icebreak == null) return;
    // console.log(icebreak);
    console.log("AI button");
    console.log(d);
    console.log("ここまで");
    chatChannel.speak([d, this.dataset.place, this.dataset.refer], 9, false, icebreak);
    // chatChannel.speak([$(t).text(), 1, 0], 1, false, this.name.substr(1));

  });

  // 前のステップへボタンを押す
  $(document).on("click", ".backward-btn", function () {
    console.log("backward button");
    chatChannel.speak([this.dataset.nexticebreak, 0, 0], 10, false, this.dataset.currenticebreak);
  });

  // 次のステップへボタンを押す
  $(document).on("click", ".forward-btn", function () {
    console.log("forward button");
    chatChannel.speak([this.dataset.nexticebreak, 0, 0], 11, false, this.dataset.currenticebreak);
  });

  // 画像生成ボタンを押す
  $(document).on("click", ".generate-image-btn", function () {
    let alert_text_areas = $("[id=img_gen_process_alertarea]");
    for(let a of alert_text_areas) {
      $(a).append("<p id='img_gen_warning_text'>現在実行中です。ページが更新されるまで操作せず、しばらくお待ち下さい。</p>");
    }
    // ボタンにdata-prpmptsを入れておくと、それを渡せる
    let d = this.dataset.prompts;
    let icebreak = this.dataset.icebreak;
    if(icebreak == null) return;
    chatChannel.speak([d, this.dataset.place, this.dataset.refer], 13, false, icebreak);
  });

  $('#GAZOU').change(function(){
    console.log("changed");
    window.URL = window.URL || window.webkitURL;
    if(window.URL){
      var IMGFILE = $('input[id="GAZOU"]').prop('files')[0];
      var IMGURL = window.URL.createObjectURL(IMGFILE);
      $('#DISP_GAZOU').attr("src", IMGURL).onload = function(){
        window.URL.revokeObjectURL(IMGURL);
      };

    }else{
      alert("ブラウザがサムネ表示に対応していません(´；ω；｀)");
    }
  });

});

// 3のrecommendを削除するリコメンド
function delrec(del_l){
  let l = '#l' + del_l;
  console.log('remove:' + l);
  $(l).remove();
}

// textを渡して、それが既に投稿されていないかチェックをしてくれる。
// true:かぶりなし、false:かぶりあり
function kaburicheck(text, place, refer){
  let r = "#r" + refer;
  place = "#p" + place;
  let p = $(r).find("td").find(place).find("p");
  let ary = []
  for(let i = 0; i < p.length; i++){
    let t = $(p[i]).text();
    t = t.replace(/\r?\n?\s/g,"");
    ary.push(t);
  }
  for(let i = 0; i < ary.length; i++){
    let idx = ary[i].indexOf("修正削除") - 1;
    // console.log("text:" + text + " ary:" + ary[i].substr(0, idx));
    if(ary[i].substr(0, idx) == text) return confirm("既に投稿されているようです。投稿しますか？\n（キャンセル：やめる　OK：投稿する）");
    // if(ary[i].match(text)) return confirm("既に投稿されているようです。投稿しますか？\n（キャンセル：やめる　OK：投稿する）")
    // if(ary[i] == text) return confirm("既に投稿されているようです。投稿しますか？\n（キャンセル：やめる　OK：投稿する）")
  }
  return true; // かぶりなし
}

function rowgen(i){
  return             "<tr id=r"+i+">\n" +
      "          <td>\n" +
      "            <div id=p1>\n" +
      "            </div>\n" +
      "            <form class=\"r"+i+"p1i7\">\n" +
      "  <input type=\"text\" id=\"r"+i+"\" class=\"p1\" value=\"\" placeholder=\"ここへ入力\" />\n" +
      "  <input type=\"button\" class=\"send\" id=\"r"+i+"\" name=\"p1\" placeholder=\"7\" value=\"共有する\"></inputbutton>\n" +
      "</form>\n" +
      "\n" +
      "          </td>\n" +
      "          <td>\n" +
      "            <div id=p2>\n" +
      "            </div>\n" +
      "            <form class=\"r"+i+"p2i7\">\n" +
      "  <input type=\"text\" id=\"r"+i+"\" class=\"p2\" value=\"\" placeholder=\"ここへ入力\" />\n" +
      "  <input type=\"button\" class=\"send\" id=\"r"+i+"\" name=\"p2\" placeholder=\"7\" value=\"共有する\"></inputbutton>\n" +
      "</form>\n" +
      "\n" +
      "          </td>\n" +
      "          <td>\n" +
      "            <div id=p3>\n" +
      "            </div>\n" +
      "            <form class=\"r"+i+"p3i7\">\n" +
      "  <input type=\"text\" id=\"r"+i+"\" class=\"p3\" value=\"\" placeholder=\"ここへ入力\" />\n" +
      "  <input type=\"button\" class=\"send\" id=\"r"+i+"\" name=\"p3\" placeholder=\"7\" value=\"共有する\"></inputbutton>\n" +
      "</form>\n" +
      "\n" +
      "          </td>\n" +
      "          <td>\n" +
      "            <div id=p4>\n" +
      "            </div>\n" +
      "            <form class=\"r"+i+"p4i7\">\n" +
      "  <input type=\"text\" id=\"r"+i+"\" class=\"p4\" value=\"\" placeholder=\"ここへ入力\" />\n" +
      "  <input type=\"button\" class=\"send\" id=\"r"+i+"\" name=\"p4\" placeholder=\"7\" value=\"共有する\"></inputbutton>\n" +
      "</form>\n" +
      "\n" +
      "          </td>\n" +
      "          <td>\n" +
      "            <div id=p5>\n" +
      "            </div>\n" +
      "            <form class=\"r"+i+"p5i7\">\n" +
      "  <input type=\"text\" id=\"r"+i+"\" class=\"p5\" value=\"\" placeholder=\"ここへ入力\" />\n" +
      "  <input type=\"button\" class=\"send\" id=\"r"+i+"\" name=\"p5\" placeholder=\"7\" value=\"共有する\"></inputbutton>\n" +
      "</form>\n" +
      "\n" +
      "          </td>\n" +
      "      </tr>";
}